import { FC, ReactNode } from 'react';
import styles from './DarkCard.module.scss';
import { Card, CardProps, Stack, Typography, TypographyProps } from '@mui/material';
import classNames from 'classnames';

export interface IDarkCardProps extends Omit<CardProps, 'title'> {
	pattern?: 'linepattern1' | 'linepattern2' | 'linepattern3' | 'linepattern4' | 'circlepattern1' | 'circlepattern2' | 'circlepattern3';
	icon?: ReactNode;
	title?: ReactNode;
	subtitle?: ReactNode;
	titleProps?: TypographyProps;
	subtitleProps?: TypographyProps;
	iconContentSpacing?: number;
}

export const DarkCard: FC<IDarkCardProps> = ({
	pattern,
	icon,
	title,
	subtitle,
	titleProps,
	subtitleProps,
	iconContentSpacing = 2,
	children,
	sx,
	...props
}) => {
	const { onClick } = props;
	return (
		<Card
			variant="outlined"
			sx={{
				backgroundColor: 'common.black',
				color: 'common.white',
				paddingX: 5,
				paddingY: 3,
				cursor: onClick ? 'pointer' : undefined,
				...sx,
			}}
			classes={{ root: classNames(styles.DarkCard, pattern ? styles[pattern] : undefined) }}
			{...props}
		>
			<Stack direction="column" spacing={iconContentSpacing}>
				{icon}
				<Stack spacing={0.5}>
					{title && (
						<Typography variant="h5" {...titleProps}>
							{title}
						</Typography>
					)}
					{subtitle && <Typography {...subtitleProps}>{subtitle}</Typography>}
				</Stack>
				{children}
			</Stack>
		</Card>
	);
};
